import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils/global-utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-base px-2.5 py-1  transition-colors focus:outline-none focus:ring-2 ",
  {
    variants: {
      variant: {
        default: " bg-black text-lewk-primary",
        light: "bg-lewk-primary text-white",
        label: " bg-black text-white ",
        secondary: "border border-lewk-grey text-black",
        destructive:
          "border-transparent bg-red-500 text-neutral-50 hover:bg-red-500/80 dark:bg-red-900 dark:text-neutral-50 dark:hover:bg-red-900/80",
        destructive_secondary: "border border-lewk-grey text-red-600",
        outline: "text-neutral-950 dark:text-neutral-50",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
